import TooltipDirective from 'primevue/tooltip'
import type { DirectiveBinding, ObjectDirective, VNode } from 'vue'

function findParentTestId(el: HTMLElement): string | null {
  let current: HTMLElement | null = el

  while (current && current !== document.body) {
    const testId = current.getAttribute('data-testid')
    if (testId) {
      return testId
    }
    current = current.parentElement
  }

  return null
}

function enhanceTooltipBinding(el: HTMLElement, binding: DirectiveBinding): DirectiveBinding {
  const originalValue = binding.value
  const parentTestId = findParentTestId(el)
  const tooltipTestId = parentTestId ? `${parentTestId}-tooltip` : 'tooltip'

  return {
    ...binding,
    value:
      typeof originalValue === 'object'
        ? {
            ...originalValue,
            pt: {
              ...(originalValue.pt || {}),
              root: {
                ...(originalValue.pt?.root || {}),
                'data-testid': tooltipTestId
              }
            }
          }
        : {
            value: originalValue,
            pt: { root: { 'data-testid': tooltipTestId } }
          }
  }
}

//Adds data-testid to the tooltip base on the parent elements data-testid
export const CustomTooltipDirective: ObjectDirective<HTMLElement> = {
  ...TooltipDirective,
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const enhancedBinding = enhanceTooltipBinding(el, binding)
    TooltipDirective.mounted?.(el, enhancedBinding, vnode, null)
  },
  updated(el: HTMLElement, binding: DirectiveBinding, vnode: VNode, prevVnode: VNode) {
    const enhancedBinding = enhanceTooltipBinding(el, binding)
    TooltipDirective.updated?.(el, enhancedBinding, vnode, prevVnode)
  }
}
